import { Box, Typography } from '@mui/material';
import React from 'react';

type Props = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

export const TabPanel = ({index, value, children, ...other}: Props) => {

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component={'span'}  variant={'body2'}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}